import { doc, collection } from 'firebase/firestore';
import { db } from '../firebase';
import { 
  PORTFOLIOS_COLLECTION,
  USERS_COLLECTION,
  LEADS_COLLECTION,
  BUSINESS_COLLECTION
} from './constants';

// Main collections for different entity types
export const portfoliosCollection = collection(db, PORTFOLIOS_COLLECTION);
export const usersCollection = collection(db, USERS_COLLECTION);
export const leadsCollection = collection(db, LEADS_COLLECTION);
export const getBusinessLeadsCollection = (businessId: string) => {
  return collection(db, BUSINESS_COLLECTION, businessId, 'leads');
};
export const businessesCollection = collection(db, BUSINESS_COLLECTION);

// We'll keep a single metadata document for tracking last updates
export const metadataRef = doc(db, 'metadata', 'appState');

// Settings document for UI state
export const uiStateRef = doc(db, 'settings', 'uiState');
